
import { createSelector } from "reselect"


const selectAuth = (state) => state.auth;

export const authSelector = createSelector(
    [selectAuth],
    (data) => ({
        token: data?.token,
        user: data?.user
    })
)